import { gql, MutationHookOptions, TypedDocumentNode } from "@apollo/client";

import {
  CreateActionMutationMutation,
  CreateActionMutationMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { usePerformMutation } from "src/graphql/utils";

import { getCustomerByIdQuery } from "../GetCustomerByIdQuery";

export const createActionMutation = gql`
  mutation CreateActionMutation(
    $entityType: EntityType!
    $entityId: String!
    $elementCode: String!
    $actionCode: String!
  ) {
    executeElementAction(
      entityType: $entityType
      entityId: $entityId
      elementCode: $elementCode
      actionCode: $actionCode
    ) {
      status
    }
  }
` as TypedDocumentNode<CreateActionMutationMutation, CreateActionMutationMutationVariables>;

export const useCreateActionMutation = ({
  onSuccess,
  onError,
  options,
}: {
  onSuccess?: () => void;
  onError?: () => void;
  options?: MutationHookOptions<
    CreateActionMutationMutation,
    CreateActionMutationMutationVariables
  >;
}) =>
  usePerformMutation(createActionMutation, {
    onSuccess,
    onError,
    mutationOption: { refetchQueries: [getCustomerByIdQuery], ...options },
  });
